import {RateLimiterError} from "@/Errors/RateLimiterError";
import {ResponseError} from "@/Stub/V1";

export const processRateLimiterErrors = async (error: unknown) => {
    if (error instanceof ResponseError) {
        if (error?.response?.status === 429) {
            throw new RateLimiterError(error?.response?.statusText ? error.response.statusText : "API rate limit exceeded. Please try again later.");
        }
    }
};
